import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as Styles from '../../assets/styles/appStyles';
import SidebarLayout from '../../common/SidebarLayout';

interface CustodianSidebarProps {
  open: boolean;
  onClose: () => void;
  custodianData: any;
  topOffset?: number;
}

const CustodianSidebar: React.FC<CustodianSidebarProps> = ({
  open,
  onClose,
  custodianData,
  topOffset = 64,
}) => {
  const navigate = useNavigate();
  if (!custodianData) return null;

  const handleMoreDetails = () =>
    navigate(`/entity/details/${custodianData.entityId}`);

  const { name, recordTypeName, address, phoneNumbers, portalUrls, contacts } =
    custodianData;

  return (
    <SidebarLayout
      open={open}
      onClose={onClose}
      topOffset={topOffset}
      title={name || 'Custodian Details'}
      onMoreDetails={handleMoreDetails}
    >
      {/* Custodian Information */}
      <Box
        sx={{
          border: '1px solid #eee',
          borderRadius: 2,
          p: 2,
          mb: 2,
          boxShadow: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}
        >
          {recordTypeName}
        </Typography>

        <Grid container spacing={2}>
          {/* Address */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Address:
            </Typography>
            <Typography variant="body2" sx={Styles.sidebarLabelText}>
              {address?.addressDetails || '-'}
            </Typography>
          </Grid>

          {/* City */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              City:
            </Typography>
            <Typography variant="body2" sx={Styles.sidebarLabelText}>
              {address?.city || '-'}
            </Typography>
          </Grid>

          {/* State */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              State:
            </Typography>
            <Typography variant="body2" sx={Styles.sidebarLabelText}>
              {address?.state || '-'}
            </Typography>
          </Grid>

          {/* Phone */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Phone:
            </Typography>
            <Typography variant="body2" sx={Styles.sidebarLabelText}>
              {phoneNumbers?.[0]?.phoneNumber || '-'}
            </Typography>
          </Grid>

          {/* Portal */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Portal:
            </Typography>
            <Typography variant="body2" sx={Styles.sidebarLabelText}>
              {portalUrls?.[0]?.portalUrl || '-'}
            </Typography>
          </Grid>

          {/* Contact Name */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Contact Name:
            </Typography>
            {contacts?.length ? (
              contacts.map((c: any, i: number) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={Styles.sidebarLabelText}
                >
                  {c.name}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" sx={Styles.sidebarLabelText}>
                -
              </Typography>
            )}
          </Grid>

          {/* Contact Phone */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Contact Phone:
            </Typography>
            {contacts?.length ? (
              contacts.map((c: any, i: number) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={Styles.sidebarLabelText}
                >
                  {c.phoneNumber}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" sx={Styles.sidebarLabelText}>
                -
              </Typography>
            )}
          </Grid>

          {/* Contact Email */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" sx={Styles.labelTitle}>
              Contact Email:
            </Typography>
            {contacts?.length ? (
              contacts.map((c: any, i: number) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={Styles.sidebarLabelText}
                >
                  {c.email}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" sx={Styles.sidebarLabelText}>
                -
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </SidebarLayout>
  );
};

export default CustodianSidebar;
